import { Component, HostBinding, Input } from '@angular/core';
import { currencify } from '../../helpers/common';
import { ReportsService } from '../../services/reports.service';
import { ViewAsService } from '../../services/view-as.service';
import { Router } from '@angular/router';
import { TipsReportItem } from '../../models/reports.model';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-tips-report-tile',
  templateUrl: './tips-report-tile.component.html',
  styleUrls: ['./tips-report-tile.component.scss']
})
export class TipsReportTileComponent {

  protected readonly currencify = currencify;

  @Input() item!: TipsReportItem;
  @Input() kind!: 'Pending' | 'Paid';

  @HostBinding('attr.id') id!: string;

  readonly$ = this.viewAsService.readonly$;

  get dividerNeed() {
    return document.getElementById(this.id)?.nextSibling?.nodeName === 'APP-TIPS-REPORT-TILE';
  }

  get checked() {
    const selected = Array.from(this.reportsService.selectedTips);
    return selected.some((item) => item.paymentId === this.item.paymentId && item.wId === this.item.wId && item.userId === this.item.userId);
  }

  get userName() {
    return `${this.item.uFirstName} ${this.item.uLastName[0]}.`;
  }

  showUserName$ = this.viewAsService.selectedUsersIds$.pipe(
    map(users => !users || users.length > 1)
  );

  constructor(
    private router: Router,
    private reportsService: ReportsService,
    private viewAsService: ViewAsService,
  ) { }

  ngOnInit() {
    this.id = `${this.item.wId}_${this.item.paymentId}_${this.kind}_${this.item.userId ?? ''}`;
  }

  async openPayment(wId: number, pId: number) {
    await this.router.navigate(['/payments', wId, pId]);
  }

  check(checked: boolean, item: any) {
    const selected = Array.from(this.reportsService.selectedTips);
    const itemInSelection = selected.find((curItem) => curItem.paymentId === item.paymentId && curItem.wId === item.wId && curItem.userId === item.userId);
    if (checked && !itemInSelection)
      this.reportsService.selectedTips.add(item);

    if (!checked && itemInSelection)
      this.reportsService.selectedTips.delete(itemInSelection);
  }
}
